import { createDomain, sample } from 'effector'
import { driverModel } from '~/entities/Driver'
import { AxiosErrorType, Driver } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain(
  'features.DriverOccupations.ChangeCurrentOccupationModal',
)

export const submit = domain.createEvent<{
  occupationId: UniqueId
  fn: () => void
}>()

export const submitFx = domain.createEffect<
  {
    occupationId: UniqueId
    fn: () => void
  },
  void,
  AxiosErrorType
>({
  async handler({ occupationId, fn }) {
    await Driver.updateCurrentOccupation(occupationId)
    await driverModel.getDriverSilentFx()
    fn()
  },
})

sample({
  clock: submit,
  target: submitFx,
})

sample({
  clock: submitFx.doneData,
  fn() {
    return {
      message: 'Тип занятости успешно изменён',
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: submitFx.failData,
  fn(e) {
    return {
      message: mapMessageErrors(e),
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
